import React from "react";

export const DominanceComp = ({ domincanceData }) => {
  return (
    <div className="mCard grayCard mb-3">
      <div className="title">Dominance</div>
      <div className="ethGasRow">
        <div className="dCol">
          <div className="name">Bitcoin</div>
          <div className="val">
            {(domincanceData?.btcDominance &&
              domincanceData?.btcDominance.toFixed(2)) ||
              0}
            %
          </div>
        </div>
        <div className="dCol">
          <div className="name">Ethereum</div>
          <div className="val">
            {(domincanceData?.ethDominance &&
              domincanceData?.ethDominance.toFixed(2)) ||
              0}
            %
          </div>
        </div>
        <div className="dCol">
          <div className="name">Others</div>
          <div className="val">
            {(domincanceData?.btcDominance &&
              (
                100 -
                domincanceData?.ethDominance -
                domincanceData?.btcDominance
              ).toFixed(2)) ||
              0}
            %
          </div>
        </div>
      </div>
      <div className="altIndicatorM">
        <div
          className="col1"
          style={{
            width: domincanceData?.btcDominance
              ? `${domincanceData?.btcDominance}%`
              : "0%",
          }}
        ></div>
        <div
          className="col4"
          style={{
            width: domincanceData?.ethDominance
              ? `${domincanceData?.ethDominance}%`
              : "0%",
          }}
        ></div>
        <div
          className="col3"
          style={{
            width: domincanceData?.btcDominance
              ? `${
                  100 -
                  domincanceData?.ethDominance -
                  domincanceData?.btcDominance
                }%`
              : "0%",
          }}
        ></div>
      </div>
    </div>
  );
};
